import { useEffect, useState } from 'react';
import { LOGIN_CARDS_HOLD_CLASS, shouldCollapseExploreSections } from './exploreSections';

const readHold = (): boolean =>
  typeof document !== 'undefined' &&
  document.documentElement.classList.contains(LOGIN_CARDS_HOLD_CLASS);

/**
 * True while the post-login Random Outcomes drawer is holding the EGM cards back
 * (its `<html>` class). Observed, not polled; a class that is already set is picked
 * up on mount.
 */
export function useLoginCardsHold(): boolean {
  const [held, setHeld] = useState<boolean>(readHold);

  useEffect(() => {
    const root = document.documentElement;
    const sync = () => setHeld(root.classList.contains(LOGIN_CARDS_HOLD_CLASS));
    sync();
    if (typeof MutationObserver === 'undefined') return undefined;
    const observer = new MutationObserver(sync);
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return held;
}

/**
 * Collapse state of the Explore drawer's Insight + Timeframe sections, derived from
 * the loading skeleton's lifecycle (so it shares its ~120ms no-flash delay) and the
 * login card hold. Independent of the scroll auto-hide state.
 */
export function useExploreSectionsCollapsed(input: {
  showDrawer: boolean;
  skeletonVisible: boolean;
}): boolean {
  const loginCardsHeld = useLoginCardsHold();
  return shouldCollapseExploreSections({ ...input, loginCardsHeld });
}
